// The button on the card of a letter template (platform П9): send the letter to the one who pressed it.

import { useState } from 'react';
import { Button, useToast } from '../ui/primitives.tsx';
import { useSync } from '../sync/react.tsx';

export function TemplateTestButton({ recordId }: { recordId: string }) {
  const client = useSync();
  const toast = useToast();
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      const r = await client.run('mail.sendTest', { templateId: recordId });
      if (r.ok) toast({ kind: 'info', text: 'Тестовое письмо отправлено — оно лежит в разделе «Письма».' });
      else toast({ kind: 'error', text: r.error.message });
    } finally {
      setBusy(false);
    }
  };
  return <Button size="sm" icon="mail" disabled={busy} onClick={send}>{busy ? 'Отправляем…' : 'Прислать мне тестовое письмо'}</Button>;
}
